import { FormControl, Checkbox, styled } from '@mui/material'
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel'

const CheckboxContainer = styled(FormControlLabel)({
  outline: 'none',
  userSelect: 'none',
})

interface StateLabel {
  checked: string
  unchecked: string
}

interface Props {
  value: boolean
  onChange: (...args: any[]) => void
  label?: string
  error?: boolean
  stateLabel?: StateLabel
}

type ControlLabelProps = Omit<FormControlLabelProps, 'control' | 'tabIndex' | 'label'>

export default function FormInputCheckbox(props: Props & ControlLabelProps) {
  const { error, ...otherProps } = props

  return (
    <FormControl error={error} fullWidth>
      <InputCheckbox {...otherProps} />
    </FormControl>
  )
}

export function InputCheckbox(props: Props & ControlLabelProps) {
  const { onChange, value, label, stateLabel, ...controlLabelProps } = props

  return (
    <CheckboxContainer
      label={CheckboxLabel(value, label, stateLabel)}
      tabIndex={0}
      {...controlLabelProps}
      control={
        <Checkbox
          size="small"
          color="primary"
          checked={value}
          onChange={(e, checked) => onChange(checked)}
        />
      }
    />
  )
}

function CheckboxLabel(
  value: boolean,
  label: string | undefined,
  stateLabel: StateLabel | undefined,
) {
  if (label) {
    return label
  }

  if (!stateLabel) {
    return undefined
  }

  return value ? stateLabel.checked : stateLabel.unchecked
}
